module.exports = __webpack_public_path__ + "img/right-guide-hero.70587fc1.png";